type LogoProps = {
  color?: "white" | "black";
  className?: string;
};

export default function LogoFooterKom({ color = "black", className = "" }: LogoProps) {
  return (
    <>
    <p>Registered and Supervised by:</p>
    <div className={`flex items-center ${className}`}>
      <img
        src="/assets/images/komdigi.png"
        alt="TalentLink Logo"
        className={`
          h-20 w-auto transition-all duration-300
          ${color === "black" ? "" : ""}
        `}
      />
      <img
        src="/assets/images/logo-kemenaker.png"
        alt="TalentLink Logo"
        className={`
          h-36 w-auto transition-all duration-300
          ${color === "black" ? "" : ""}
        `}
      />
    </div>
    </>
  );
}
